export default __webpack_public_path__ + "static/media/cuti.3ee4e66b.png";